// extracted by mini-css-extract-plugin
export default {"container":"TableauAlarmeXY_container__HXp-y"};